import { render, staticRenderFns } from "./agreementModal.vue?vue&type=template&id=395bdaa2&scoped=true"
import script from "./agreementModal.vue?vue&type=script&lang=js"
export * from "./agreementModal.vue?vue&type=script&lang=js"
import style0 from "./agreementModal.vue?vue&type=style&index=0&id=395bdaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395bdaa2",
  null
  
)

export default component.exports